import { render, staticRenderFns } from "./TableCellRedirectsSourceUrl.vue?vue&type=template&id=5b9c6067&scoped=true"
import script from "./TableCellRedirectsSourceUrl.vue?vue&type=script&lang=js"
export * from "./TableCellRedirectsSourceUrl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9c6067",
  null
  
)

export default component.exports